import { authHeader } from '../helpers';
import handleResponse from './handleResponse';
import { sourceWebsiteConstants } from '_constants';

export const sourceWebsiteService = {
    doAction,
    getAll,
    getById,
    _delete,
};


function doAction(sourceWebsiteId, action, data = []) {
    return kick({
        'action': action,
        'sourceWebsiteId': sourceWebsiteId,
        'data' : data
    });
}

function kick(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch( process.env.REACT_APP_API_ENDPOINT + `/api/source-website-kick`, requestOptions).then(handleResponse);
}

function getAll(departmentIds = [], text = '', page = '', per_page='')  {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(process.env.REACT_APP_API_ENDPOINT + `/api/source-website?departmentIds=${departmentIds.join()}&text=${text}&page=${page}&per_page=${per_page}`, requestOptions).then(handleResponse);
}

function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(process.env.REACT_APP_API_ENDPOINT + `/api/source-website/${id}`, requestOptions).then(handleResponse);
}

function _delete(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(process.env.REACT_APP_API_ENDPOINT + `/api/source-website/${id}`, requestOptions).then(handleResponse);
}

